export const HOSTED_ORIGIN = 'https://play.swkotor.net';

export const SEO_DISCLAIMER =
  'Not affiliated with Lucasfilm, Disney, BioWare, Obsidian, EA, Steam, or GOG.';

export const SEO_GAME_FILES_NOTICE =
  'Requires your own legally obtained PC game files; none are included with this project.';
